module.exports = __webpack_public_path__ + "img/baseline-cloud_upload-24px.3f7e59cc.svg";